<template>
  <transition name="slide">   
      <b-card no-body>
        <b-card-header>
              Role List
              <div class="pull-right">
                  <b-button size="sm" variant="primary" v-b-tooltip.hover title="Add New" @click.stop="add()"><i class="fa fa-plus"></i> Add New</b-button>
              </div>  
        </b-card-header>
        <b-card-body>
        <b-row>
          <b-col md="1">
              <b-form-select :options="pageOptions" v-model="perPage" />
          </b-col>
          <b-col md="4" offset-md="7">
                <b-input-group>
                  <b-form-input v-model="filter" placeholder="Type to Search" />
                  <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''"><i class="fa fa-times-circle"></i></b-btn>
                  </b-input-group-append>
                </b-input-group>
          </b-col>  
        </b-row>
        <br/>   
        <b-table responsive show-empty id="roletable" :busy.sync="isBusy" :filter="filter" :items="myProvider" :fields="fields" :current-page="currentPage" :per-page="perPage">
          <template v-slot:cell(roleindex)="data">
            <strong>{{data.item.roleindex}}</strong>
          </template>
          <template v-slot:cell(createddate)="data">
            {{data.item.createddate | dateTimeFormat }}
          </template>
          
          <template v-slot:cell(action)="data">
            <b-dropdown text="Action" size="sm" right>
              <b-dropdown-item-button v-b-tooltip.hover title="Edit" @click.stop="info(data.item)">
                <i class="fa fa-edit"></i>Edit 
              </b-dropdown-item-button>
              <b-dropdown-item-button v-b-tooltip.hover title="Delete" @click.stop="del(data.item)">
                <i class="fa fa-remove"></i>Delete
              </b-dropdown-item-button>
              <b-dropdown-item-button v-b-tooltip.hover title="Reset password" @click.stop="viewPermission(data.item)">
                <i class="fa fa-lock" ></i>View Role Permission
              </b-dropdown-item-button>
            </b-dropdown>  
          </template>
        </b-table>
        <nav v-if="totalRows>0">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
      </b-card-body>
      </b-card>
  </transition>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex' 
import { getResponseMessages } from '../../_helpers';
export default {
  name: 'Role_List',
  data: () => {
    return {
      itemsData: [],
      fields: [
        {key: 'roleindex',sortable:true,label: 'Role Index'},
        {key: 'rolename',sortable:true,label: 'Role Name'},
        {key: 'roleweight',sortable:true,label: 'Role Weight'},
        {key: 'createddate',sortable:true, label: 'Created Date'},
        {key: 'action',label: 'Action'}
      ],
      isBusy: false,
      lastPerPage: 5,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      pageOptions: [ 5, 25, 50, 100 ],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null
    }
  },
  computed: {
    ...mapGetters(["getRecordTotal", "getRecords"])
  },      
  methods: {
    ...mapActions('org', ['getList','delById']),
    myProvider(ctx){
      this.isBusy = true
      if(this.lastPerPage != ctx.perPage){
        this.lastPerPage = ctx.perPage;
        ctx.currentPage = 1;
      }
      var startVal = (ctx.currentPage-1) * ctx.perPage
      ctx['start'] = startVal
      ctx['length'] = ctx.perPage
      this.itemsData = [];
      let promise = this.$store.dispatch('getList',{ url:'role/index',data: ctx })
      let itemsx = []
      return promise.then((res) => {
          itemsx = this.$store.state.org.records
          this.totalRows = this.$store.state.org.recordTotal
          return(itemsx)
      })
      return(itemsx)
    },
    dateFormat (){
      return 'kishore'
    },  
    info (item) {
        this.$router.push('/role/edit/'+item.roleindex)
    },
    add () {
        this.$router.push('/role/add')
    },
    viewPermission (item) {
        this.$router.push('/role/rolepermission/'+item.roleindex)
    },
    del(item) {
        this.$swal({
            title: 'Are you sure?',
            text: 'You want to remove this role!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
          }).then((result) => {
            if (result.value) {
                this.$store.dispatch('delById', {url:'role/removeRole',data : { 'roleIndex':item.roleindex }}).then((res) => {
                  
                  this.$swal('Deleted!',getResponseMessages(res.data.messages),'success')
                  this.$root.$emit('bv::refresh::table', 'roletable');
                },(error) =>{
                  this.$swal('Cancelled',getResponseMessages(error.data.messages),'error')
                });
            }
          })
    } 
  }
}
</script>